import * as React from "react";

const SvgIcon = ({ className, opacity }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" opacity={ opacity }>
    <defs>
      <linearGradient id="vvvortex-grad" x1="50%" x2="50%" y1="0%" y2="100%">
        <stop offset="0%" stopColor="hsl(0, 0%, 100%)"></stop>
        <stop offset="100%" stopColor="hsl(0, 0%, 100%)"></stop>
      </linearGradient>
    </defs>
    <g
      fill="none"
      stroke="url(#vvvortex-grad)"
      strokeDashoffset="25"
      strokeLinecap="round"
    >
      <circle
        cx="400"
        cy="400"
        r="858"
        strokeDasharray="35 41"
        strokeWidth="11"
        opacity="0.05"
        transform="rotate(124 400 400)"
      ></circle>
      <circle
        cx="400"
        cy="400"
        r="841.5"
        strokeDasharray="41 49"
        strokeWidth="11"
        opacity="0.07"
        transform="rotate(25 400 400)"
      ></circle>
      <circle
        cx="400"
        cy="400"
        r="825"
        strokeDasharray="54 18"
        strokeWidth="11"
        opacity="0.09"
        transform="rotate(210 400 400)"
      ></circle>
      <circle
        cx="400"
        cy="400"
        r="808.5"
        strokeDasharray="46 15"
        strokeWidth="11"
        opacity="0.11"
        transform="rotate(23 400 400)"
      ></circle>
      <circle
        cx="400"
        cy="400"
        r="792"
        strokeDasharray="27 27"
        strokeWidth="11"
        opacity="0.12"
        transform="rotate(156 400 400)"
      ></circle>
      <circle
        cx="400"
        cy="400"
        r="775.5"
        strokeDasharray="34 12"
        strokeWidth="10"
        opacity="0.14"
        transform="rotate(214 400 400)"
      ></circle>
      <circle
        cx="400"
        cy="400"
        r="759"
        strokeDasharray="32 47"
        strokeWidth="10"
        opacity="0.16"
        transform="rotate(204 400 400)"
      ></circle>
      <circle
        cx="400"
        cy="400"
        r="742.5"
        strokeDasharray="41 29"
        strokeWidth="10"
        opacity="0.18"
        transform="rotate(173 400 400)"
      ></circle>
      <circle
        cx="400"
        cy="400"
        r="726"
        strokeDasharray="53 44"
        strokeWidth="10"
        opacity="0.2"
        transform="rotate(330 400 400)"
      ></circle>
      <circle
        cx="400"
        cy="400"
        r="709.5"
        strokeDasharray="48 49"
        strokeWidth="10"
        opacity="0.22"
        transform="rotate(279 400 400)"
      ></circle>
      <circle
        cx="400"
        cy="400"
        r="693"
        strokeDasharray="53 23"
        strokeWidth="10"
        opacity="0.24"
        transform="rotate(142 400 400)"
      ></circle>
      <circle
        cx="400"
        cy="400"
        r="676.5"
        strokeDasharray="15 20"
        strokeWidth="10"
        opacity="0.25"
        transform="rotate(153 400 400)"
      ></circle>
      <circle
        cx="400"
        cy="400"
        r="660"
        strokeDasharray="32 38"
        strokeWidth="10"
        opacity="0.27"
        transform="rotate(359 400 400)"
      ></circle>
      <circle
        cx="400"
        cy="400"
        r="643.5"
        strokeDasharray="46 37"
        strokeWidth="9"
        opacity="0.29"
        transform="rotate(198 400 400)"
      ></circle>
      <circle
        cx="400"
        cy="400"
        r="627"
        strokeDasharray="10 20"
        strokeWidth="9"
        opacity="0.31"
        transform="rotate(262 400 400)"
      ></circle>
      <circle
        cx="400"
        cy="400"
        r="610.5"
        strokeDasharray="47 13"
        strokeWidth="9"
        opacity="0.33"
        transform="rotate(271 400 400)"
      ></circle>
      <circle
        cx="400"
        cy="400"
        r="594"
        strokeDasharray="26 24"
        strokeWidth="9"
        opacity="0.35"
        transform="rotate(28 400 400)"
      ></circle>
      <circle
        cx="400"
        cy="400"
        r="577.5"
        strokeDasharray="35 44"
        strokeWidth="9"
        opacity="0.37"
        transform="rotate(193 400 400)"
      ></circle>
      <circle
        cx="400"
        cy="400"
        r="561"
        strokeDasharray="32 31"
        strokeWidth="9"
        opacity="0.39"
        transform="rotate(257 400 400)"
      ></circle>
      <circle
        cx="400"
        cy="400"
        r="544.5"
        strokeDasharray="30 27"
        strokeWidth="9"
        opacity="0.4"
        transform="rotate(322 400 400)"
      ></circle>
      <circle
        cx="400"
        cy="400"
        r="528"
        strokeDasharray="32 14"
        strokeWidth="9"
        opacity="0.42"
        transform="rotate(286 400 400)"
      ></circle>
      <circle
        cx="400"
        cy="400"
        r="511.5"
        strokeDasharray="42 50"
        strokeWidth="9"
        opacity="0.44"
        transform="rotate(188 400 400)"
      ></circle>
      <circle
        cx="400"
        cy="400"
        r="495"
        strokeDasharray="18 37"
        strokeWidth="8"
        opacity="0.46"
        transform="rotate(124 400 400)"
      ></circle>
      <circle
        cx="400"
        cy="400"
        r="478.5"
        strokeDasharray="34 45"
        strokeWidth="8"
        opacity="0.48"
        transform="rotate(60 400 400)"
      ></circle>
      <circle
        cx="400"
        cy="400"
        r="462"
        strokeDasharray="12 28"
        strokeWidth="8"
        opacity="0.5"
        transform="rotate(227 400 400)"
      ></circle>
      <circle
        cx="400"
        cy="400"
        r="445.5"
        strokeDasharray="33 22"
        strokeWidth="8"
        opacity="0.52"
        transform="rotate(206 400 400)"
      ></circle>
      <circle
        cx="400"
        cy="400"
        r="429"
        strokeDasharray="36 30"
        strokeWidth="8"
        opacity="0.53"
        transform="rotate(267 400 400)"
      ></circle>
      <circle
        cx="400"
        cy="400"
        r="412.5"
        strokeDasharray="54 30"
        strokeWidth="8"
        opacity="0.55"
        transform="rotate(135 400 400)"
      ></circle>
      <circle
        cx="400"
        cy="400"
        r="396"
        strokeDasharray="34 13"
        strokeWidth="8"
        opacity="0.57"
        transform="rotate(27 400 400)"
      ></circle>
      <circle
        cx="400"
        cy="400"
        r="379.5"
        strokeDasharray="53 19"
        strokeWidth="8"
        opacity="0.59"
        transform="rotate(253 400 400)"
      ></circle>
      <circle
        cx="400"
        cy="400"
        r="363"
        strokeDasharray="47 30"
        strokeWidth="7"
        opacity="0.61"
        transform="rotate(115 400 400)"
      ></circle>
      <circle
        cx="400"
        cy="400"
        r="346.5"
        strokeDasharray="23 12"
        strokeWidth="7"
        opacity="0.63"
        transform="rotate(101 400 400)"
      ></circle>
      <circle
        cx="400"
        cy="400"
        r="330"
        strokeDasharray="29 16"
        strokeWidth="7"
        opacity="0.65"
        transform="rotate(29 400 400)"
      ></circle>
      <circle
        cx="400"
        cy="400"
        r="313.5"
        strokeDasharray="26 52"
        strokeWidth="7"
        opacity="0.66"
        transform="rotate(61 400 400)"
      ></circle>
      <circle
        cx="400"
        cy="400"
        r="297"
        strokeDasharray="49 54"
        strokeWidth="7"
        opacity="0.68"
        transform="rotate(332 400 400)"
      ></circle>
      <circle
        cx="400"
        cy="400"
        r="280.5"
        strokeDasharray="51 34"
        strokeWidth="7"
        opacity="0.7"
        transform="rotate(2 400 400)"
      ></circle>
      <circle
        cx="400"
        cy="400"
        r="264"
        strokeDasharray="24 39"
        strokeWidth="7"
        opacity="0.72"
        transform="rotate(316 400 400)"
      ></circle>
      <circle
        cx="400"
        cy="400"
        r="247.5"
        strokeDasharray="34 24"
        strokeWidth="7"
        opacity="0.74"
        transform="rotate(310 400 400)"
      ></circle>
      <circle
        cx="400"
        cy="400"
        r="231"
        strokeDasharray="18 36"
        strokeWidth="7"
        opacity="0.76"
        transform="rotate(205 400 400)"
      ></circle>
      <circle
        cx="400"
        cy="400"
        r="214.5"
        strokeDasharray="35 51"
        strokeWidth="6"
        opacity="0.78"
        transform="rotate(325 400 400)"
      ></circle>
      <circle
        cx="400"
        cy="400"
        r="198"
        strokeDasharray="19 11"
        strokeWidth="6"
        opacity="0.8"
        transform="rotate(125 400 400)"
      ></circle>
      <circle
        cx="400"
        cy="400"
        r="181.5"
        strokeDasharray="35 25"
        strokeWidth="6"
        opacity="0.81"
        transform="rotate(268 400 400)"
      ></circle>
      <circle
        cx="400"
        cy="400"
        r="165"
        strokeDasharray="33 38"
        strokeWidth="6"
        opacity="0.83"
        transform="rotate(358 400 400)"
      ></circle>
      <circle
        cx="400"
        cy="400"
        r="148.5"
        strokeDasharray="38 19"
        strokeWidth="6"
        opacity="0.85"
        transform="rotate(306 400 400)"
      ></circle>
      <circle
        cx="400"
        cy="400"
        r="132"
        strokeDasharray="36 14"
        strokeWidth="6"
        opacity="0.87"
        transform="rotate(158 400 400)"
      ></circle>
      <circle
        cx="400"
        cy="400"
        r="115.5"
        strokeDasharray="26 39"
        strokeWidth="6"
        opacity="0.89"
        transform="rotate(239 400 400)"
      ></circle>
      <circle
        cx="400"
        cy="400"
        r="99"
        strokeDasharray="14 36"
        strokeWidth="6"
        opacity="0.91"
        transform="rotate(272 400 400)"
      ></circle>
      <circle
        cx="400"
        cy="400"
        r="82.5"
        strokeDasharray="29 13"
        strokeWidth="5"
        opacity="0.93"
        transform="rotate(149 400 400)"
      ></circle>
      <circle
        cx="400"
        cy="400"
        r="66"
        strokeDasharray="49 38"
        strokeWidth="5"
        opacity="0.94"
        transform="rotate(332 400 400)"
      ></circle>
      <circle
        cx="400"
        cy="400"
        r="49.5"
        strokeDasharray="51 48"
        strokeWidth="5"
        opacity="0.96"
        transform="rotate(274 400 400)"
      ></circle>
      <circle
        cx="400"
        cy="400"
        r="33"
        strokeDasharray="11 54"
        strokeWidth="5"
        opacity="0.98"
        transform="rotate(129 400 400)"
      ></circle>
      <circle
        cx="400"
        cy="400"
        r="16.5"
        strokeDasharray="18 29"
        strokeWidth="5"
        transform="rotate(344 400 400)"
      ></circle>
    </g>
  </svg>
);

export default SvgIcon;
